import clsx from 'clsx';
import { Color } from '../../lib/types.ts';
import { ReactNode } from 'react';
import { Button } from '../buttons/Button.tsx';

interface VideoCardProps {
    color: Color | 'white';
    heading: string;
    subheading: string;
    video: ReactNode;
    withButton?: () => void;
}

export default function VideoCard({
    color,
    heading,
    subheading,
    video,
    withButton,
}: VideoCardProps) {
    const colorVariants = {
        white: 'bg-white',
        blue: 'bg-blue-100',
        green: 'bg-green-100',
        orange: 'bg-orange-100',
        red: 'bg-red-100',
        turquoise: 'bg-turquoise-100',
        purple: 'bg-purple-100',
        rose: 'bg-rose-100',
    };

    return (
        <div
            className={clsx(
                'flex flex-col items-start justify-between gap-2 rounded-xl px-4 py-4',
                'bg-gradient-to-r', // TODO: should be 100deg
                colorVariants[color]
            )}
        >
            <div className="flex w-full flex-row justify-between">
                <div>
                    <h5>{heading}</h5>
                    {subheading && (
                        <p className="text-sm font-light text-gray-500">
                            {subheading}
                        </p>
                    )}
                </div>
                {withButton && <div className="shrink-0 grow-0">
                    <Button color="orange" variant="secondary" onClick={withButton}>
                        Kdy použít
                    </Button>
                </div>}
            </div>
            {video}
        </div>
    );
}
